module.exports = __webpack_public_path__ + "static/media/aeon.f6145689.svg";